<template>
    <div class="s-inputCheck">
       
        <div class="backAll">
            <div class="text-field">
                <template v-if="inpuMask">
                    <b-form-input
                        :class="myClass"
                        :id="id"
                        :name="name"
                        :disabled="disabled"
                        autocomplete= "off"
                        :type="type"
                        :maxlength="maxlength"
                        v-the-mask="inpuMask"
                        v-model="inputValue"
                        :trim="true"
                        :state="isInputValid"
                        :readonly="readonly">
                    </b-form-input>
                </template>
                <template v-else>
                    <b-form-input
                        :class="myClass"
                        :id="id"
                        :name="name"
                        :disabled="disabled"
                        autocomplete= "off"
                        :type="type"
                        :maxlength="maxlength"
                        v-model="inputValue"
                        :trim="true"
                        :state="isInputValid"
                        :readonly="readonly">
                    </b-form-input>    
                </template>
                <label>{{placeholder}}</label>
            </div>
           
            <div class="checkSpace">
                <b-form-checkbox switch size="sm" v-model="checkValue" :state="checkState">{{ checklabel }}</b-form-checkbox>
            </div>
        </div>
 
    </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'
export default{
    name: "s-inputCheck",
    props: ['value', 'myClass', 'id', 'name','disabled','autocomplete', 'type', 'maxlength','placeholder','inpuMask','isInputState', 'checkState', 'readonly', 'checked', 'checklabel'],
    data: function() {
        return {
            patterns : {
                email:"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,}$", //Valide l'adresse courriel
                phonenumber : "\\(\\d{3}\\)\\s\\d{3} \\d{4}"  //Valide le telephone au format (###) ### ####

            }
        }
    },
    directives: {
        'the-mask': AwesomeMask
    },
    methods:{
        isValid : (str) => (!(str === "undefined" || str?.length == 0))
    },
    computed: {
        inputValue: {
            get: function() {
                let sendValue = this.value
                return sendValue
                },
            set: function(modifiedValue) { this.$emit('update:value', modifiedValue)}
        },
        checkValue: {
            get: function() { return this.checked},
            set: function(modifiedValue) { 
                this.$emit('update:checked', this.$CObj(modifiedValue))
            }
        },
        isInputValid() {
            switch(this.type) {
                case 'email':
                    var re = new RegExp(this.patterns.email)
                    return this.isInputState ? this.isValid(this.inputValue) ? re.test(this.inputValue) : false : null
                case 'tel':
                    var reTel = new RegExp(this.patterns.phonenumber)
                    return this.isInputState ? reTel.test(this.inputValue) : null
                default:
                    return null;
            }
        }
    }
}
 
 
</script>
 
<style lang="scss" scoped>
 
.checkSpace{
    margin-left: 10px;
}
 
.text-field {
        position: relative;
        margin: 0.1em;
    }
 
.backAll{
    border: solid thin $ServexGray;
    border-radius: 5px;
}
 
input {
        //display: inline-block;
        height: 40px;
        border: solid 0 $ServexGray;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        //border: solid thin $ServexGray;
        //border-top: solid 1px $ServexBlue;
        //border-bottom: solid 0px $ServexBlue;
        border: solid 1px $ServexGray;
        color: $ServexBlue;
        background-color: $ServexMainColorOpposite;
        padding: 20px 10px 10px 10px;
        //border-radius: $sBorderRadius;
        //box-shadow: 0.2px 0.2px 0.2px 0.2px transparent
    }
 
    input:focus {
            background-color: $ServexMainColorOpposite;
            outline: none;
            //box-shadow: 0.2px 0.2px 0.2px 0.2px $ServexShadow;
            box-shadow: 0px 0px 0.5px 0.5px $MainColor;
        }
 
label {
        font-size: smaller; //small;
        position: absolute;
        pointer-events: none;
        top: 1px;
        left: 5px;
        color: $MainColor; //$ServexBlue;
        background-color:transparent;
        padding:0 5px 0 5px;
        transition: 0.2s;
        border-radius: 10px;
    }
 
input:focus ~ label {
        //font-size: 10px; //small;
        color: $ServexLightGray; //$MainColor; //$ServexBlue;
        border-radius: 10px;
        //padding:0 15px 0 15px;
    }
</style>